module.exports = __webpack_public_path__ + "img/university-sci-service.d84876a5.png";